export const emitLogin = function (result: any) {
  const customEvent = new CustomEvent("ourforestLogin", { "detail": { email: result.user.email, token: result.token } });
  document.dispatchEvent(customEvent);
}
